export function convertPriceToClient(price: number) {
  return price / 100;
}

export function convertPriceToServer(price: number) {
  return Number((price * 100).toFixed());
}
